<link id="theme" rel="stylesheet" href="https://www.w3schools.com/lib/w3-theme-blue.css">
<div class="w3-bar w3-top w3-theme-d5 w3-large" style="z-index:4">
  <button class="w3-bar-item w3-hide-large w3-hover-none w3-hover-text-light-grey w3-theme-d5" (click)="w3_open();"><i
      class="fa fa-bars"></i>  Menu</button>
  <span class="w3-bar-item w3-right">StudyBio</span>
</div>

<!-- Sidebar/menu -->
<nav class="w3-sidebar w3-collapse w3-white w3-animate-left" style="z-index:3;width:300px;" id="mySidebar"><br>
  <div class="w3-container w3-row">
    <div class="w3-col s4">
      <img [src]="user.getImage()" class="w3-circle w3-margin-right" style="width:46px">
    </div>
    <div class="w3-col s8 w3-bar">
      <span>Welcome, <strong>{{user.getName()}}</strong></span><br>
      <button matTooltip="My Profile" [routerLink]="['/']" class="w3-bar-item w3-button"><i
          class="fa fa-user"></i></button>
      <a matTooltip="Change Theme" (click)="openColor()" class="w3-bar-item w3-button"><i
          class="fa fa-paint-brush"></i></a>
      <a matTooltip="Logout" (click)="user.logout()" class="w3-bar-item w3-button"><i class="fa fa-key"></i></a>

    </div>
  </div>
  <hr>


  <table style="width:100%">
    <tr>
      <td colspan="6"><button [routerLink]="['teacher']" mat-button style="width:100%" class="w3-theme-d2"><i
            class="fa fa-cog"></i> Teacher Panel </button>
      </td>
    </tr>

    <tr>

      <td colspan="2" style="width:33%">
        <button mat-button (click)="setExam('CE')" [class.w3-theme-d2]="current_exam == 'CE'" style="width:100%"
          class=" w3-theme-l5 w3-half"> HKCEE </button>
      </td>
      <td colspan="2" style="width:33%">
        <button mat-button (click)="setExam('DSE')" [class.w3-theme-d2]="current_exam == 'DSE'" style="width:100%"
          class="w3-theme-l5 w3-half"> HKDSE </button>
      </td>
      <td colspan="2" style="width:33%">
        <button mat-button (click)="setExam('Others')" [class.w3-theme-d2]="current_exam == 'Others'" style="width:100%"
          class="w3-theme-l5 w3-half"> OTHER </button>
      </td>

    </tr>


    <tr>
      <td colspan="3" style="width:50%">
        <button mat-button (click)="setPaper('mc')" [class.w3-theme-d2]="current_paper == 'mc'" style="width: 100%"
          class="w3-theme-l5"> MCQ.</button>
      </td>
      <td colspan="3" style="width:50%">
        <button [class.w3-disabled]="current_exam == 'Others'" [disabled]="current_exam == 'Others'" mat-button
          (click)="setPaper('sq')" [class.w3-theme-d2]="current_paper == 'sq'" style="width: 100%" class="w3-theme-l5">
          SQ. </button>
      </td>
      <!-- <td colspan="2" style="width:50%">
        <button [class.w3-disabled]="current_exam == 'Others' || current_exam == 'CE'" [disabled]="current_exam == 'Others' || current_exam == 'CE'" mat-button (click)="setPaper('p2')" [class.w3-theme-d2]="current_paper == 'p2'" style="width: 100%" class="w3-theme-l5">   P2.   </button>
        </td> -->
    </tr>


    <tr>
      <td colspan="3" style="width:33%">
        <button [class.w3-disabled]="current_exam == 'Others'" [disabled]="current_exam == 'Others'" mat-button
          (click)="setType('year')" [class.w3-theme-d2]="current_type == 'year'" style="width: 100%"
          class="w3-yellow w3-theme-l5">
          By Year
        </button>
      </td>

      <td colspan="3" style="width:33%">
        <button [class.w3-disabled]="current_paper == 'p2'" [disabled]="current_paper == 'p2'" mat-button
          (click)="setType('topic')" [class.w3-theme-d2]="current_type == 'topic'" style="width: 100%"
          class="w3-theme-l5"> By Topic</button>
      </td>

    </tr>

  </table>

  <div class="w3-container">
    <h5>{{current_exam}} - {{current_paper | uppercase}} - By {{current_type}}</h5>
  </div>



  <span *ngIf="current_type == 'year' && current_exam == 'CE' ">
    <div class="w3-bar-block" *ngFor="let paper of CEpapers; index as paperId">
      <button style="width: 100%;text-align: left;" mat-button (click)="setYear(paper.id)"
        [class.w3-theme-l4]="paper.id == year" [routerLink]="[current_paper,current_exam,current_type, paper.id]">
        <i class="fa fa-pencil fa-fw"></i>  {{ paper.name }}</button>
    </div>
  </span>
  <span *ngIf="current_type == 'year'  && current_exam == 'DSE' ">
    <div class="w3-bar-block" *ngFor="let paper of DSEpapers; index as paperId">
      <button style="width: 100%;text-align: left;" mat-button (click)="setYear(paper.id)"
        [class.w3-theme-l4]="paper.id == year" [routerLink]="[current_paper,current_exam,current_type, paper.id]">
        <i class="fa fa-pencil fa-fw"></i>  {{ paper.name }}</button>
    </div>
  </span>


  <span *ngIf="current_type == 'topic'">
    <div class="w3-bar-block" *ngFor="let topic of topics">
      <button style="width: 100%;text-align: left;" mat-button (click)="setTopic(topic.tag)"
        [class.w3-theme-l4]="topic.tag === current_topic"
        [routerLink]="[current_paper,current_exam,current_type, topic.tag]">
        <i class="fa fa-pencil fa-fw"></i>  {{ topic.name}}</button>
    </div>
  </span>

  <span *ngIf="current_type == 'sqtype'">
    <div class="w3-bar-block" *ngFor="let type of sqtype">
      <button class="w3-disabled" style="width: 100%;text-align: left;">
        <i class="fa fa-pencil fa-fw"></i>  {{ type.name}}</button>
    </div>
  </span>

  <br>
  <br>
  <br>
  <br>
</nav>
<!-- Overlay effect when opening sidebar on small screens -->
<div class="w3-overlay w3-hide-large w3-animate-opacity" (click)="w3_close()" style="cursor:pointer"
  title="close side menu" id="myOverlay"></div>
<script>

</script>